// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class SubscriptionStrategyRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_SUBSCRIPTION_STRATEGY_REQUEST_MESSAGE, fieldSet);
    }
    getTradingSystemId() {
        return this.getFieldValue(FieldsFactory.FIELD_TRADING_SYSTEM_ID);
    }
    setTradingSystemId(tradingSystemId) {
        this.setFieldValue(FieldsFactory.FIELD_TRADING_SYSTEM_ID, tradingSystemId);
    }
    getTradingStrategySubscriptionStatus() {
        return this.getFieldValue(FieldsFactory.FIELD_TRADING_STRATEGY_SUBSCRIPTION_STATUS);
    }
    setTradingStrategySubscriptionStatus(subscriptionStatus) {
        this.setFieldValue(FieldsFactory.FIELD_TRADING_STRATEGY_SUBSCRIPTION_STATUS, subscriptionStatus);
    }
}
